import { Link } from "react-router-dom";
import { AdListing } from "types/adListing";

interface AdListImageProps {
  ilan: AdListing;
  style: React.CSSProperties;
  detailLink?: string;
  disableDetailLinks?: boolean;
}

export default function AdListImage({ ilan, style, detailLink, disableDetailLinks = false }: AdListImageProps) {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement;
    target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect fill="%23f0f0f0" width="200" height="200"/%3E%3Ctext fill="%23999" x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle"%3ENo image%3C/text%3E%3C/svg%3E';
    target.onerror = null;
  };
  const image = (
    <img
      src={ilan.resimUrl || '/assets/images/placeholder.jpg'}
      className="card-img-top"
      alt={ilan.baslik}
      style={style}
      onError={handleImageError}
    />
  );

  if (disableDetailLinks) {
    return image;
  }

  const to = detailLink ?? `/ilan-detay/${ilan.id}`;
  return <Link to={to}>{image}</Link>;
}